<template>
  <div>
    <div class="clearfix">
      <div class="fl">
        <div class="advanceBox mb20" v-if="show">
          <img src="@/assets/images/question/advance.png" alt="" />
        </div>
        <div class="searchBox">
          <searchList type="index" ref="search" @advance="advance" />
        </div>
      </div>
      <div class="fr">
        <div class="navBox">
          <div class="caozuo">
            <div class="curp" @click="myContent(1, '我的回答')">
              <div class="pinglBox">
                <i class="iconfont">&#xe698;</i>
              </div>
              <p>我的回答</p>
            </div>
            <div class="curp" @click="myContent(2, '历史浏览')">
              <div class="recordBox">
                <i class="iconfont">&#xe749;</i>
              </div>
              <p>历史浏览记录</p>
            </div>
            <div>
              <div class="collectBox curp" @click="myContent(3, '我的收藏')">
                <i class="iconfont">&#xe605;</i>
              </div>
              <p>我的收藏</p>
            </div>
          </div>
        </div>
        <div class="listBox">
          <lastUpdate class="mt20" />
          <hotSearch class="mt20" @getTitle="titleChange" />
          <hotQuestion class="mt20" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import searchList from "./components/search-list";
import lastUpdate from "./components/lastUpdate-list";
import hotSearch from "./components/hotSearch-list";
import hotQuestion from "./components/hotQuestion-list";
export default {
  data() {
    return {
      title: "",
      show: true,
    };
  },
  components: { searchList, lastUpdate, hotSearch, hotQuestion },
  methods: {
    //跳转我的内容
    myContent(type, visitlocation) {
      var url = "";
      if (type == 1) {
        url = "/user/comment";
      }
      if (type == 2) {
        url = "/user/history";
      }
      if (type == 3) {
        url = "/user/collect?tabValue=qa";
      }
      this.$router.push({
        path: url,
      });
    },

    //点击热搜
    titleChange(data) {
      sessionStorage.setItem("title", "");
      this.$refs.search.handleSearch(data);
    },
    //搜索存在内容(控制头部图标是否展示)
    advance(data) {
      //this.show = data
    },
  },
  created() {
    this.$store.dispatch("analysis/updateHits", {
      visitlocation: "每日一问",
    });
  },
  mounted() {
    var title = sessionStorage.getItem("title");
    if (title) {
      setTimeout(() => {
        this.$refs.search.handleSearch(title);
      }, 500);
    }
  },
};
</script>
<style>
.advanceBox {
  width: 850px;
  height: 150px;
  background-color: #fff;
  border-radius: 10px;
  text-align: center;
  line-height: 150px;
}
.advanceBox img {
  border-radius: 10px;
}
.navBox {
  width: 340px;
  height: 150px;
  border-radius: 10px;
  padding-top: 40px;
  background-color: #fff;
}
.caozuo {
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.pinglBox,
.recordBox,
.collectBox {
  width: 40px;
  height: 40px;
  line-height: 30px;
  margin: 0 auto;
  border-radius: 50%;
  text-align: center;
  font-size: 28px;
  margin-bottom: 10px;
}
.pinglBox {
  background-color: #c9d8f9;
}
.recordBox {
  background-color: #e4e2e0;
}
.collectBox {
  background-color: #e4e2e0;
}
.searchBox {
  width: 850px;
  background-color: #fff;
  border-radius: 10px;
}
.listBox {
  width: 340px;
  border-radius: 10px;
}
</style>
